import React, { useState, useEffect } from 'react';
import './ResourceControl.css';
import './App.css'; // Import global styles for app-shell
import LoadingIndicator from './LoadingIndicator';
import AppSidebar from './AppSidebar';

// --- HELPER FUNCTIONS ---
function getInitials(user) {  
  const source = user?.emp_name || user?.username || 'User';
  return source.split(' ').filter(Boolean).slice(0, 2).map((part) => part[0]?.toUpperCase()).join('');
}

function getUserColor(userName) {
  if (!userName) return '#5b6ee1';
  let hash = 0;
  for (let i = 0; i < userName.length; i++) {
    hash = ((hash << 5) - hash) + userName.charCodeAt(i);
    hash = hash & hash; 
  }
  const colors = ['#5b6ee1', '#ec4899', '#f97316', '#06b6d4', '#8b5cf6', '#10b981', '#f43f5e', '#6366f1', '#14b8a6', '#d97706'];
  return colors[Math.abs(hash) % colors.length];
}

// --- SVGS ---
function LogoMark() {
  return (
    <svg width="90" height="18" viewBox="0 0 1046 120" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M30 120H5a5 5 0 0 1-5-5V5a5 5 0 0 1 5-5h25a5 5 0 0 1 5 5v37.5a5 5 0 0 0 5 5h4.795a20 20 0 0 0 13.418-5.17l43.93-39.745A10 10 0 0 1 108.852 0h39.572c2.299 0 3.38 2.841 1.661 4.369L89.602 58.132a2.5 2.5 0 0 0 0 3.736l60.483 53.763c1.719 1.528.638 4.369-1.661 4.369h-39.572a10 10 0 0 1-6.709-2.585l-43.93-39.746A20 20 0 0 0 44.795 72.5H40a5 5 0 0 0-5 5V115a5 5 0 0 1-5 5m181.361 0h-27.929c-1.802 0-3.013-1.85-2.29-3.502L230.799 2.996A5 5 0 0 1 235.38 0h38.46a5 5 0 0 1 4.581 2.996l49.657 113.502c.722 1.652-.488 3.502-2.291 3.502h-27.928a5 5 0 0 1-4.569-2.969l-34.111-76.75c-1.76-3.96-7.379-3.96-9.138 0l-34.111 76.75a5 5 0 0 1-4.569 2.969" fill="#1f1f1f" />
      <path fillRule="evenodd" clipRule="evenodd" d="M363.29 0h111.615c16.568 0 30 13.432 30 30v22.814c0 12.988-8.961 24.259-21.615 27.186l24.808 36.084c1.14 1.658-.048 3.916-2.061 3.916h-30.174c-1.615 0-3.13-.78-4.069-2.094l-17.522-24.53A20 20 0 0 0 437.998 85H398.29a5 5 0 0 0-5 5v25a5 5 0 0 1-5 5h-25a5 5 0 0 1-5-5V5a5 5 0 0 1 5-5m35 25h65c5.523 0 10 4.477 10 10v15c0 5.523-4.477 10-10 10h-65a5 5 0 0 1-5-5V30a5 5 0 0 1 5-5M653.542 0h-110a5 5 0 0 0-5 5v110a5 5 0 0 0 5 5h115c16.568 0 30-13.431 30-30v-5.96a28.88 28.88 0 0 0-17.5-26.54 25.75 25.75 0 0 0 12.5-22.077V30c0-16.568-13.432-30-30-30m-15 25h-60a5 5 0 0 0-5 5v12.5a5 5 0 0 0 5 5h60c5.522 0 10-4.477 10-10V35c0-5.523-4.478-10-10-10m-60 47.5h65c5.522 0 10 4.477 10 10V85c0 5.523-4.478 10-10 10h-65a5 5 0 0 1-5-5V77.5a5 5 0 0 1 5-5" fill="#1f1f1f" />
      <path d="M748.972 120h-27.928c-1.803 0-3.013-1.85-2.29-3.502L768.411 2.996A5 5 0 0 1 772.992 0h38.46a5 5 0 0 1 4.58 2.996l49.658 113.502c.722 1.652-.488 3.502-2.291 3.502h-27.928a5 5 0 0 1-4.569-2.969l-34.111-76.75c-1.76-3.96-7.379-3.96-9.138 0l-34.112 76.75a5 5 0 0 1-4.569 2.969m176.93 0h-25a5 5 0 0 1-5-5V5a5 5 0 0 1 5-5h35.145a30 30 0 0 1 26.007 15.046l44.186 76.837c1.27 2.22 4.66 1.314 4.66-1.246V5a5 5 0 0 1 5-5h25a5 5 0 0 1 5 5v110c0 2.761-2.24 5-5 5h-35.14a30 30 0 0 1-26.009-15.046L935.57 28.117c-1.277-2.22-4.668-1.314-4.668 1.246V115a5 5 0 0 1-5 5" fill="#1f1f1f" />
    </svg>
  );
}

const SearchIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <circle cx="11" cy="11" r="8" />
    <path d="m21 21-4.35-4.35" />
  </svg>
);

const SettingsIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <circle cx="12" cy="12" r="3" />
    <path d="M12 1v6m0 6v6M4.22 4.22l4.24 4.24m5.08 5.08l4.24 4.24M1 12h6m6 0h6M4.22 19.78l4.24-4.24m5.08-5.08l4.24-4.24" />
  </svg>
);

const CheckIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <polyline points="20 6 9 17 4 12" />
  </svg>
);

function ResourceControl({ user, onLogout, loggingOut, onNavigateToDashboard, onNavigateToTasks, onNavigateToFMS, onNavigateToReturns, onNavigateToDelegation, onNavigateToAllTasks, onNavigateToRegister, onNavigateToResourceControl, onNavigateToLogging }) {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [changes, setChanges] = useState({});
  const [notification, setNotification] = useState(null);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const hasAccess = user?.role === 1 || user?.role === 2;

 useEffect(() => {
      document.title = 'Resource Control';
    }, []);

  useEffect(() => {
    if (hasAccess) loadUsers();
  }, [hasAccess]);

  const loadUsers = async () => {
    setLoading(true);
    try {
      const res = await fetch('/api/resource-access/users', { credentials: 'include' });
      const data = await res.json();
      if (data.success) {
        setUsers(data.users);
      } else {
        showNotification('Failed to load users', 'error');
      }
    } catch (error) {
      showNotification('Error loading users', 'error');
    } finally {
      setLoading(false);
    }
  };

  const showNotification = (message, type = 'success') => {
    setNotification({ message, type });
    setTimeout(() => setNotification(null), 4000);
  };

  const toggleAccess = (userId, resource) => {
    setChanges(prev => {
      const userChanges = prev[userId] || { ...users.find(u => u.id === userId)?.resource_access };
      return { ...prev, [userId]: { ...userChanges, [resource]: !userChanges[resource] } };
    });
  };

  const getResourceAccess = (userId, resource) => {
    if (changes[userId]) return changes[userId][resource];
    const user = users.find(u => u.id === userId);
    return user?.resource_access?.[resource] || false;
  };

  const saveChanges = async (userId) => {
    if (!changes[userId]) return;
    setSaving(true);
    try {
      const res = await fetch(`/api/resource-access/users/${userId}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ resource_access: changes[userId] })
      });
      const data = await res.json();
      
      if (data.success) {
        setUsers(users.map(u => u.id === userId ? { ...u, resource_access: changes[userId] } : u));
        setChanges(prev => {
          const newChanges = { ...prev };
          delete newChanges[userId];
          return newChanges;
        });
        showNotification(`Access updated for ${users.find(u => u.id === userId)?.emp_name}`, 'success');
      } else {
        showNotification(data.message || 'Failed to update access', 'error');
      }
    } catch (error) {
      showNotification('Error saving changes', 'error');
    } finally {
      setSaving(false);
    }
  };

  const hasChanges = (userId) => userId in changes;
  const filteredUsers = users.filter(u =>
    u.emp_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    u.username?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    u.mail_id?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="app-shell">
      {/* Sidebar - Matches global app style */}
      <AppSidebar
        user={user}
        active="resourceControl"
        onLogout={onLogout}
        loggingOut={loggingOut}
        onNavigateToDashboard={onNavigateToDashboard}
        onNavigateToTasks={onNavigateToTasks}
        onNavigateToFMS={onNavigateToFMS}
        onNavigateToReturns={onNavigateToReturns}
        onNavigateToDelegation={onNavigateToDelegation}
        onNavigateToAllTasks={onNavigateToAllTasks}
        onNavigateToResourceControl={onNavigateToResourceControl}
        onNavigateToLogging={onNavigateToLogging}
      />

      {/* Main Workspace Area */}
      <main className="workspace">
        <header className="topbar">
          <div className="mobile-left">
            <button className="mobile-menu-btn" type="button" onClick={() => setMobileMenuOpen(true)} />
            <div className="mobile-topbar-brand"><LogoMark /></div>
          </div>
          {/* <div className="search-box">
            <span className="search-icon" aria-hidden="true" />
            <input type="search" placeholder="Search tasks, teams, or tags..." />
          </div> */}
          <div className="topbar-actions">
            <div className="avatar-placeholder" style={{ background: getUserColor(user?.emp_name || user?.username) }}>
              {getInitials(user)}
            </div>
          </div>
        </header>

        <section className="board-shell" style={{ overflowY: 'auto', backgroundColor: '#f5f7fa', padding: '24px' }}>
          {notification && (
            <div className={`rc-notification rc-notification-${notification.type}`}>
              {notification.message}
            </div>
          )}

          {!hasAccess ? (
            <div className="rc-unauthorized" style={{ background: 'white', padding: '60px', borderRadius: '8px', boxShadow: '0 1px 3px rgba(0,0,0,0.08)' }}>
              <SettingsIcon />
              <h2>Access Denied</h2>
              <p>You do not have permission to access Resource Control. Only Admin and MIS users can manage resource access.</p>
              <button className="rc-btn-primary" onClick={() => onNavigateToDashboard()}>Back to Dashboard</button>
            </div>
          ) : (
            <div style={{ maxWidth: '1400px', margin: '0 auto', width: '100%' }}>
              <header style={{ marginBottom: '24px' }}>
                <h1 style={{ fontSize: '24px', fontWeight: 600, color: '#1e293b', margin: 0 }}>Resource Control</h1>
                <p style={{ color: '#64748b', marginTop: '4px', fontSize: '14px' }}>Manage user access to system resources</p>
              </header>

              <div className="rc-search-bar" style={{ marginBottom: '24px' }}>
                <SearchIcon />
                <input
                  type="text"
                  placeholder="Search by name, username, or email..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="rc-search-input"
                />
              </div>

              {loading ? (
                <div className="rc-loading">
                  <LoadingIndicator variant="page" label="Loading users..." />
                </div>
              ) : filteredUsers.length === 0 ? (
                <div className="rc-empty-state">
                  <SettingsIcon />
                  <h3>No users found</h3>
                  <p>{searchTerm ? 'Try adjusting your search' : 'No active users available'}</p>
                </div>
              ) : (
                <div className="rc-table-wrapper">
                  <table className="rc-table">
                    <thead>
                      <tr>
                        <th>Employee Name</th>
                        <th>Email</th>
                        <th>Designation</th>
                        <th className="rc-resource-header">Dashboard</th>
                        <th className="rc-resource-header">Create User</th>
                        <th className="rc-resource-header">FMS Dashboard</th>
                        <th className="rc-resource-header">Delegation Tasks</th>
                        <th className="rc-resource-header">Return/Reverse</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredUsers.map((u) => (
                        <tr key={u.id} className={hasChanges(u.id) ? 'rc-row-modified' : ''}>
                              <td className="rc-user-name">
                                  <div
                                      className="rc-user-avatar"
                                      style={{ background: getUserColor(u.emp_name || u.username) }}
                                  >
                                      {getInitials(u)}
                                  </div>
                                  <div>
                                      <div className="rc-emp-name">{u.emp_name}</div>
                                      <div className="rc-username">{u.username}</div>
                                  </div>
                              </td>
                          <td className="rc-email">{u.mail_id}</td>
                          <td className="rc-designation">{u.designation || '-'}</td>
                          <td className="rc-toggle-cell">
  <button 
    className={`rc-toggle ${getResourceAccess(u.id, 'Dashboard') ? 'rc-toggle-on' : 'rc-toggle-off'}`} 
    onClick={() => toggleAccess(u.id, 'Dashboard')}
  >
    {getResourceAccess(u.id, 'Dashboard') && <CheckIcon />}
  </button>
</td>
                          <td className="rc-toggle-cell">
                            <button className={`rc-toggle ${getResourceAccess(u.id, 'create_user') ? 'rc-toggle-on' : 'rc-toggle-off'}`} onClick={() => toggleAccess(u.id, 'create_user')}>
                              {getResourceAccess(u.id, 'create_user') && <CheckIcon />}
                            </button>
                          </td>
                          
                          <td className="rc-toggle-cell">
                            <button className={`rc-toggle ${getResourceAccess(u.id, 'FMS_dashboard') ? 'rc-toggle-on' : 'rc-toggle-off'}`} onClick={() => toggleAccess(u.id, 'FMS_dashboard')}>
                              {getResourceAccess(u.id, 'FMS_dashboard') && <CheckIcon />}
                            </button>
                          </td>
                          <td className="rc-toggle-cell">
                            <button className={`rc-toggle ${getResourceAccess(u.id, 'Delegation_tasks') ? 'rc-toggle-on' : 'rc-toggle-off'}`} onClick={() => toggleAccess(u.id, 'Delegation_tasks')}>
                              {getResourceAccess(u.id, 'Delegation_tasks') && <CheckIcon />}
                            </button>
                          </td>
                          <td className="rc-toggle-cell">
                            <button className={`rc-toggle ${getResourceAccess(u.id, 'Return_reverse_logistics') ? 'rc-toggle-on' : 'rc-toggle-off'}`} onClick={() => toggleAccess(u.id, 'Return_reverse_logistics')}>
                              {getResourceAccess(u.id, 'Return_reverse_logistics') && <CheckIcon />}
                            </button>
                          </td>
                          <td className="rc-actions">
                            {hasChanges(u.id) ? (
                              <button className="rc-btn-save" onClick={() => saveChanges(u.id)} disabled={saving}>
                                {saving ? 'Saving...' : 'Save'}
                              </button>
                            ) : (
                              <span className="rc-no-changes">No changes</span>
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          )}
        </section>

        {loggingOut && (
          <div className="workspace-loader">
            <LoadingIndicator variant="panel" label="Logging out..." />
          </div>
        )}
      </main>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="mobile-nav-overlay" onClick={() => setMobileMenuOpen(false)}>
          <aside className="mobile-nav-sheet" onClick={(e) => e.stopPropagation()}>
            <div className="mobile-nav-head">
              <div className="mobile-nav-brand"><LogoMark /></div>
              <button className="icon-btn small icon-close" type="button" onClick={() => setMobileMenuOpen(false)} />
            </div>
            <nav className="mobile-nav-list">
              <button className="mobile-nav-item" onClick={() => onNavigateToDashboard()}>Dashboard</button>
              <button className="mobile-nav-item" onClick={() => onNavigateToTasks()}>Tasks</button>
              <button className="mobile-nav-item active">Resource Control</button>
              <button className="mobile-nav-item" onClick={onLogout} disabled={loggingOut}>
                {loggingOut ? <LoadingIndicator variant="button" label="Logging out..." /> : 'Logout'}
              </button>
            </nav>
          </aside>
        </div>
      )}
    </div>
  );
}

export default ResourceControl;
